// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// --- RxJs
import { catchError } from 'rxjs/operators';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { environment } from '../../../../environments/environment';
import { JournalQuadrantModel } from '../../../models';
import { AppService } from '../app.service';
import { QuadrantsBaseService } from './quadrants-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class QuadrantsService extends QuadrantsBaseService {
  constructor(
    private http: HttpClient,
    appService: AppService,
    translateService: TranslateService,
  ) {
    super(appService, translateService);
  }


    load(override ?: boolean): void {
      if(this._quadrants$.value && override !== true) {
        return;
    }
    this.appService.setLoading(true);

    const url =
      environment.apiConfig.surveyApiUrl +
      environment.apiConfig.quadrantsApi;

    this.http
      .get<JournalQuadrantModel[]>(url)
      .pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._createError.bind(this))
      )
      .subscribe((result: JournalQuadrantModel[] | null) => {
        if (!result) return;
        
        this.appService.setLoading(false);
        this._quadrants$.next(result);
        const styles = result.map(q => q.categoryModels)
          .reduce((a, b) => a.concat(b))
          .sort((a, b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1);
        this._styles$.next(styles);
        if (!this._currentId$.value && Array.isArray(result) && result.length > 0) {
          this._currentId$.next(result[0].id);
        }
      });
  }
}
